import { TextField as MUITextField } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import TableRow from "@material-ui/core/TableRow";
import { DatePicker } from "@material-ui/pickers";
import {
  StyleCheckbox,
  StyledTableCell,
  useStyles
} from "components/request-document/components/Commons";
import { getErrorMessage, isError } from "libs/utils/form";
import { get } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { canEditForm } from "redux/modules/authSlice";
import { selectMasterData } from "redux/modules/masterSlice";

const TextField = React.memo(MUITextField);

export default function PersonalInfoSection({ formik, disabled = false }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const canEdit = useSelector(canEditForm);

  const masterData = useSelector(selectMasterData);
  const nationalityConfig = get(masterData, "nationalityConfig", []);
  const titleConfig = get(masterData, "titleConfig", []);

  return (
    <>
      <TableRow>
        <StyledTableCell colSpan={1}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Title</InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                // style={{ width: 200 }}
                error={isError("personal.title", formik)}
              >
                <InputLabel shrink={formik.values.personal?.titleID && titleConfig.length}>Select Title</InputLabel>
                <Select
                  label="Select Title"
                  name="personal.titleID"
                  value={formik.values.personal?.titleID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={disabled || !canEdit}
                  notched={formik.values.personal?.titleID && titleConfig.length}
                >
                  {titleConfig.map((title) => (
                    <MenuItem value={title.titleID} key={title.titleID}>
                      {title.titleEN}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText error={isError("personal.titleID", formik)}>
                  {getErrorMessage("personal.titleID", formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>First name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.fistName"
                value={formik.values.personal.fistName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.fistName", formik)}
                helperText={getErrorMessage("personal.fistName", formik)}
                disabled={disabled || !canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Middle name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.middleName"
                value={formik.values.personal.middleName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.middleName", formik)}
                helperText={getErrorMessage("personal.middleName", formik)}
                disabled={disabled || !canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Last name</InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.lastName"
                value={formik.values.personal.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.lastName", formik)}
                helperText={getErrorMessage("personal.lastName", formik)}
                disabled={disabled || !canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>
                Current Nationality / Nationality at birth, if different
              </InputLabel>
              <FormControl
                variant="outlined"
                className={classes.formControl}
                // style={{ width: 200 }}
                error={isError("personal.nationalityID", formik)}
              >
                <InputLabel shrink={formik.values.personal?.nationalityID && nationalityConfig.length}>Select your nationality</InputLabel>
                <Select
                  label="Selected your nationality"
                  name="personal.nationalityID"
                  value={formik.values.personal.nationalityID}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  disabled={disabled || !canEdit}
                  notched={formik.values.personal?.nationalityID && nationalityConfig.length}
                >
                  {nationalityConfig.map((nationality) => (
                    <MenuItem
                      value={nationality.nationalityID}
                      key={nationality.nationalityID}
                    >
                      {nationality.nationalityName}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText
                  error={isError("personal.nationalityID", formik)}
                >
                  {getErrorMessage("personal.nationalityID", formik)}
                </FormHelperText>
              </FormControl>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Date of birth (dd-mm-yyyy)</InputLabel>
              <DatePicker
                // style={{ width: 200 }}
                className={classes.formControl}
                inputVariant="outlined"
                disableFuture={false}
                openTo="year"
                format="DD-MM-YYYY"
                label="Date of birth"
                views={["year", "month", "date"]}
                name={`personal.birthDate`}
                value={get(formik.values, `personal.birthDate`, null) || null}
                onChange={(date) => {
                  formik.setFieldValue(
                    `personal.birthDate`,
                    date.format("YYYY-MM-DD")
                  );
                }}
                error={isError(`personal.birthDate`, formik)}
                helperText={getErrorMessage(`personal.birthDate`, formik)}
                disabled={disabled || !canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={2}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel style={{ wordBreak: "break-all" }}>
                Place of birth (city, province/state, country)
              </InputLabel>
              <TextField
                variant="outlined"
                className={classes.textField}
                name="personal.placeOfBirth"
                value={formik.values.personal.placeOfBirth}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.placeOfBirth", formik)}
                helperText={getErrorMessage("personal.placeOfBirth", formik)}
                disabled={disabled || !canEdit}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>

      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Gender</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={disabled || !canEdit}
                      name="personal.gender"
                      value="M"
                      checked={formik.values.personal.gender === "M"}
                      onClick={() => {
                        formik.setFieldValue("personal.gender", "M");
                      }}
                    />
                  }
                  label="Male"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={disabled || !canEdit}
                      name="personal.gender"
                      value="F"
                      checked={formik.values.personal.gender === "F"}
                      onClick={() => {
                        formik.setFieldValue("personal.gender", "F");
                      }}
                    />
                  }
                  label="Female"
                />
              </FormGroup>
              <FormHelperText error={isError("personal.gender", formik)}>
                {getErrorMessage("personal.gender", formik)}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Marital status</InputLabel>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={disabled || !canEdit}
                      name="Single"
                      value="S"
                      checked={formik.values.personal.MaritalID === "S"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "S");
                        formik.setFieldValue("personal.MaritalID", "S");
                      }}
                    />
                  }
                  label="Single"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={disabled || !canEdit}
                      name="Married"
                      value="M"
                      checked={formik.values.personal.MaritalID === "M"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "M");
                        formik.setFieldValue("personal.MaritalID", "M");
                      }}
                    />
                  }
                  label="Married"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={disabled || !canEdit}
                      name="Divorced"
                      value="D"
                      checked={formik.values.personal.MaritalID === "D"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "D");
                        formik.setFieldValue("personal.MaritalID", "D");
                      }}
                    />
                  }
                  label="Divorced"
                />
                <FormControlLabel
                  control={
                    <StyleCheckbox
                      disabled={disabled || !canEdit}
                      name="Window"
                      value="W"
                      checked={formik.values.personal.MaritalID === "W"}
                      onClick={() => {
                        formik.setFieldValue("document.Marittal", "W");
                        formik.setFieldValue("personal.MaritalID", "W");
                      }}
                    />
                  }
                  label="Widowed"
                />
              </FormGroup>
              <FormHelperText error={isError("document.Marittal", formik)}>
                {getErrorMessage("document.Marittal", formik)}
              </FormHelperText>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>


      <TableRow>
        <StyledTableCell colSpan={3}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>Home / mobile phone number</InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.mobile"
                inputProps={{ maxLength: 10 }}
                onKeyDown={(e) => {
                  const pattern = /[^0-9]/g;
                  const isNotAllow =
                    e.key.length === 1 && pattern.test(e.key);

                  if (isNotAllow) {
                    e.preventDefault();
                  }
                }}
                value={formik.values.personal?.mobile}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.mobile", formik)}
                helperText={getErrorMessage("personal.mobile", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
        <StyledTableCell colSpan={4}>
          <div className={classes.cellContent}>
            <div className={classes.wrapField}>
              <InputLabel>E-mail address</InputLabel>
              <TextField
                disabled={disabled || !canEdit}
                variant="outlined"
                className={classes.textField}
                name="personal.email"
                value={formik.values.personal?.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={isError("personal.email", formik)}
                helperText={getErrorMessage("personal.email", formik)}
              />
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
}
